import { useState } from 'react'
import { useMutation, useQuery } from '@tanstack/react-query'
import { getInternalNotesList, updateInternalNote } from 'services/internalNotes'

export function useInternalNoteState() {
  const [noteState, setNoteState] = useState('')

  const handleInternalNoteContentChange = content => {
    setNoteState(content)
  }
  const resetInternalNoteState = () => {
    setNoteState('')
  }

  return {
    content: noteState,
    resetInternalNoteState,
    handleChange: handleInternalNoteContentChange,
  }
}

export function useInternalNoteList(internalNotableId, internalNotableType) {
  //fetch list for current person/org using react query
  const query = useQuery({
    queryKey: ['internalNoteItems', internalNotableId, internalNotableType],
    queryFn: () => getInternalNotesList({ internalNotableId, internalNotableType }),
    refetchOnWindowFocus: false,
    throwOnError: true,
    enabled: Boolean(internalNotableId),
  })

  // mutation for updating an internal note and refreshing the internal note list/table
  const updateInternalNoteMutation = useMutation({
    mutationFn: internalNoteData =>
      updateInternalNote(internalNoteData.internalNoteId, internalNoteData.content),
    onSuccess: () => {
      // When the mutation is successful refresh the note table
      query.refetch()
    },
  })

  return {
    internalNotesLoading: query.isPending,
    internalNoteList: query.data,
    updateInternalNoteTableItem: (internalNoteId, content) => {
      updateInternalNoteMutation.mutate({ internalNoteId, content })
    },
  }
}
